let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aUk88")).then(() => parcelRequire('jJZSp'));